import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

/* ============== 价盘调价任务 ============== */

// 定价方式下拉（FIXED/DISCOUNT/ADD/FORMULA）
export const findPriceAdjustTypes = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceAdjust/types`,
    method: 'GET',
  });
};

// 调价预览（不写库）
export const previewPriceAdjust = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceAdjust/preview`,
    method: 'POST',
    data,
  });
};

// 提交调价（生成审批单）
export const submitPriceAdjust = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceAdjust/submit`,
    method: 'POST',
    data,
  });
};

// 驳回调价任务重新提交（后端按本次参数重新试算并更新原审批单）
export const resubmitPriceAdjust = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceAdjust/resubmit`,
    method: 'POST',
    data,
  });
};

// 调价任务分页列表（批次维度，调价管理页主列表；priceBookId 必填）
export const findPriceAdjustTaskList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceAdjust/taskList?` + params,
    method: 'GET',
  });
};

// 调价任务明细列表（明细级，排障用，页面勿用）
export const findPriceAdjustList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceAdjust/list?` + params,
    method: 'GET',
  });
};

// 作废调价任务
export const cancelPriceAdjust = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/priceAdjust/cancel`,
    method: 'POST',
    data,
  });
};
